import { User } from "types";
import * as htmlToImg from "html-to-image";
import axios from "axios";
import { config } from "config";
// import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';

type Params = Record<string, string>;

export function extractFromQuery<P extends object = Params>(query: string) {
  const result = {} as P;
  const str = query.startsWith("?") ? query.slice(1) : query;
  const parts = str.split("&");
  const pairs = parts.map((part) => part.split("="));

  for (const [key, value] of pairs) {
    const k = decodeURIComponent(key) as keyof P;
    const v = decodeURIComponent(value) as unknown as P[keyof P];
    result[k] = v;
  }

  return result;
}

export function displayUser(user: User) {
  return user?.firstName
    ? `${user.firstName} ${user?.lastName || ""}`
    : user && user?.email
      ? user!.email
      : null;
}

export async function htmlToBlob(node: HTMLElement) {
  return await htmlToImg.toBlob(node);
}

export async function htmlToImage(node: HTMLElement) {
  return await htmlToImg.toPng(node);
}

export async function recordActivity(data: {
  data: {
    user: string;
    event: string;
    source: string;
    data: any;
  };
}) {
  await axios.post(`${config.apiUrl}/api/record-activity`, data);
}
